module.exports = __webpack_public_path__ + "img/著作02.59fab1d1.jpg";